module.exports = __webpack_public_path__ + "static/media/SAW-Logo_farbig-positiv_RGB.c1bf36c4.svg";